/**
 * @nullable
 */
export type ArticleMetricsModelPpmCode =
    | (typeof ArticleMetricsModelPpmCode)[keyof typeof ArticleMetricsModelPpmCode]
    | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleMetricsModelPpmCode = {
    I: 'I',
    G: 'G',
    P: 'P',
    O: 'O',
    E: 'E',
    N: 'N',
    NA: 'NA'
} as const;
